import { MouseEvent } from 'react'
import { Button } from 'react-bootstrap'
import { FaTrash as RemoveIcon } from 'react-icons/fa'

import { VacinaService } from '@core/services'
import { Alert } from '@core/gateways'
import { useModal } from '@presentation/hooks'
import { Modal } from '@presentation/components/organisms'
import { ModalProps } from '@presentation/types/components/organisms'

type Props = {
  comprovanteId: string
  onCancel: Function
}

const CancelEnvioModal: React.FC<Props> = ({ comprovanteId, onCancel }) => {
  const { isOpen, openModal, closeModal } = useModal()

  const onSuccess = async () => {
    closeModal()
    if (onCancel) {
      onCancel()
    }
    await Alert.call({
      title: 'Cancelado com Sucesso',
      type: 'success'
    })
  }

  const onError = async (error: Error) => {
    closeModal()
    await Alert.call({
      title: 'Falha no Cancelamento',
      description: error.message,
      type: 'error'
    })
  }

  const onConfirm = async (event: MouseEvent<HTMLButtonElement>) => {
    try {
      await VacinaService.cancelEnvio({
        id: comprovanteId
      })
      await onSuccess()
    } catch (error) {
      await onError(error as Error)
    }
  }

  const buttonActions = [
    <Button variant="success" onClick={onConfirm}>
      Confirmar
    </Button>
  ]
  const configs: ModalProps = {
    isOpen,
    icon: <RemoveIcon />,
    title: `Cancelamento de Envio`,
    description: `Tem certeza de que deseja cancelar o envio do comprovante ?`,
    actions: buttonActions,
    size: 'sm',
    onClose: closeModal
  }

  return (
    <>
      <Button variant="danger" onClick={openModal}>
        Cancelar Envio
      </Button>
      <Modal {...configs}></Modal>
    </>
  )
}

export default CancelEnvioModal
